export const documentTopOffset = () => document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;